import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import cn from 'classnames';

import styles from './Header.module.postcss';

function MobileSubMenu({ children, active, onClose }) {
  return (
    <nav
      className={cn(styles.SubNav, {
        [styles.SubNav_active]: active,
      })}
      aria-hidden={!active}
    >
      <div className={styles.SubNav_Header}>
        <button
          type='button'
          className={styles.HeaderMenuToggle}
          onClick={onClose}
        >
          <SVG src='/static/images/icons/material-ui-chevron-left.svg' alt='Back' height='16' width='16' />
        </button>
      </div>
      <div className={styles.SubNav_Content}>
        {children}
      </div>
    </nav>
  );
}

MobileSubMenu.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
};

export default MobileSubMenu;
